





































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'

@Component
export default class ComponentBackofficeCadastroMedicoMedicosEAssistentesTable extends Vue {
  medicoTableHeaders: any[] = [
    { text: 'Nome do médico', class: 'table-headers', align: 'left', value: 'medicoLogin', sortable: false },
    { text: 'CPF do médico', class: 'table-headers', align: 'left', value: 'medicoCpf', sortable: false },
    { text: 'Login do médico', class: 'table-headers', align: 'center', value: 'medicoLogin', sortable: false },
    { text: 'Nome da secretária', class: 'table-headers', align: 'left', value: 'secretariaNome', sortable: false },
    { text: 'Login da secretária', class: 'table-headers', align: 'center', value: 'secretariaLogin', sortable: false },
    { text: 'E-mails', class: 'table-headers', align: 'center', value: 'emails', sortable: false },
  ]

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get medicosCadastrados() {
    return this.getBackofficeCadastroMedicoStore.medicosCadastrados
  }

  get medicoSearch() { return this.getBackofficeCadastroMedicoStore.medicoSearch }
  set medicoSearch(value: string) { this.getBackofficeCadastroMedicoStore.setMedicoSearch(value) }

  get tableLoading() { return this.getBackofficeCadastroMedicoStore.conviteTableLoading }

  filterMedicos(items, search, filter) {
    return items.filter(({ medicoNome, medicoCpf }) => {
      const mNome = medicoNome !== undefined ? medicoNome.toLowerCase() : ''
      const mCpf = medicoCpf !== undefined ? medicoCpf : ''
      const s = search.toLowerCase()
      return mNome.includes(s) || mCpf.includes(s)
    })
  }

  displayEmail(el: string[]) {
    if (typeof el === 'undefined') return '-'
    if (el.length < 1) return '-'
    if (el.length === 1) return el[0]
    let results = ''
    for (let i = 0; i < el.length; i++) {
      results += `<span style="display: block">${el[i]}</span>`
    }
    return results
  }
}
